<template>
  <div>
    <p class="title" :class="{'has-text-white': white}">Add tracker</p>
    <p class="control has-icons-left">
      <input v-model="id" class="input" name="trackerid" type="text" placeholder="ID of tracker">
      <span class="icon is-small is-left" :class="{'has-text-success': isAdded}">
        <i class="fas fa-lock"></i>
      </span>
    </p>
    <p class="help is-danger" v-if="error">{{error}}</p>
    <button :disabled="loading" class="button is-primary" @click="addTracker()">Add</button>
  </div>
</template>

<script>
export default {
  data: () => {
    return {
      id: '',
      loading: false,
      isAdded: false,
      error: null
    }
  },
  props: {
    white: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    async addTracker () {
      this.loading = true
      this.error = null
      const result = await this.$store.dispatch('addTracker', this.id)
      this.loading = false
      if (result.error) this.error = result.message
    }
  }
}
</script>

<style scoped>
.button {
  margin-top: 1em;
}
</style>
